import { DataGrid } from "../../../../components";
import { Box, Card, CardContent, Chip, Divider, Typography } from "@mui/joy";

import { columnDef } from "./grid-column";
import { useProject } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { Search } from "lucide-react";

export default function ManageProject() {
    const { useList } = useProject();
    const listProjectSvc = useList();

    const [project, setProject] = useState([]);

    const fetchData = async () => {
        try {
            const response = await listProjectSvc.mutateAsync().catch(console.error);
            setProject(response);
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Card sx={{ mt: 2, p: 0 }}>
            <CardContent>
                <Box p={2}>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box>
                            <Typography level="title-lg" mb={2}>
                                Manage Projects
                            </Typography>
                            <Box display={"flex"} gap={1}>
                                <Chip sx={{ borderRadius: 6, border: "1px solid", borderColor: "divider" }}>
                                    Priority
                                </Chip>
                                <Chip sx={{ borderRadius: 6, border: "1px solid", borderColor: "divider" }} disabled>
                                    Active
                                </Chip>
                                <Chip sx={{ borderRadius: 6, border: "1px solid", borderColor: "divider" }} disabled>
                                    Completed
                                </Chip>
                                <Chip sx={{ borderRadius: 6, border: "1px solid", borderColor: "divider" }} disabled>
                                    Cancelled
                                </Chip>
                            </Box>
                        </Box>
                        <Box mr={1}>
                            <Search size={18} />
                        </Box>
                    </Box>
                </Box>
                <Divider />
                <Box>
                    <DataGrid gridData={project} columnDefs={columnDef} autoHeight={true} />
                </Box>
            </CardContent>
        </Card>
    );
}
